import Avatar from './Avatar'
import './IdentityBand.css'

/**
 * The band that says WHOSE page this is.
 *
 * Every "about one person or one organisation" screen in the panel opened the
 * same way: a page header with nothing in it but the section title, then
 * straight into a form or a table. You could read half the screen before
 * learning who you were looking at.
 *
 * The band answers that in one line — face, name, and the two or three facts
 * that identify them — and leaves the far end free for whatever that page
 * measures. `children` is that slot; on التقارير الشخصية it holds the points
 * standing, and on a page with nothing to count it stays empty and the band
 * simply ends.
 *
 * @param {{icon: import('react').ElementType, text: string, ltr?: boolean}[]} [meta]
 * @param {import('react').ReactNode} [status]  badges, under the meta line
 */
export default function IdentityBand({ name, meta = [], status, children }) {
  return (
    <section className="identity-band">
      <Avatar name={name} size="lg" />

      <div className="identity-band__main">
        <h2 className="identity-band__name">
          <bdi>{name}</bdi>
        </h2>

        {meta.length > 0 && (
          <div className="identity-band__meta">
            {meta.map(({ icon: Icon, text, ltr }) => (
              <span key={text}>
                <Icon size={14} strokeWidth={1.75} aria-hidden="true" />
                <bdi {...(ltr ? { dir: 'ltr' } : null)}>{text}</bdi>
              </span>
            ))}
          </div>
        )}

        {status && <div className="identity-band__status">{status}</div>}
      </div>

      {children}
    </section>
  )
}
